import { useEffect, useState } from 'react';

import Sidebar from '../components/Sidebar';

import { supabase } from '../supabase/config';

import './Schedule.css';

const Schedule = () => {

    const [events, setEvents] = useState([]);


    const getEvents = async () => {

        const { data, error } = await supabase
        .from('schedule')
        .select('*');

        if(data){
            setEvents(data);
        }

        if(error){
            console.log(error);
        }
    }


    useEffect(() => {

        getEvents();

    }, []);


    return (

        <div className="schedule-page">

            <Sidebar />

            <div className="schedule-content">

                <h1>Event Schedule</h1>

                <p className="schedule-text">
                    Manage all event sessions and timings.
                </p>



                {/* Cards */}

                <div className="schedule-container">

                    {events.map((item) => (

                        <div
                            className="schedule-card"
                            key={item.id}
                        >

                            <div className="schedule-top">

                                <h2>{item.event_name}</h2>

                                <span>

                                    Live

                                </span>

                            </div>


                            <div className="schedule-info">

                                <p>
                                    📍 {item.location}
                                </p>

                                <p>
                                    📅 {item.event_date}
                                </p>

                                <p>
                                    ⏰ {item.start_time} - {item.end_time}
                                </p>

                            </div>

                        </div>

                    ))}

                </div>



                {/* Table */}

                <div className="schedule-table">

                    <h2>Upcoming Sessions</h2>

                    <table>

                        <thead>

                            <tr>

                                <th>Event</th>
                                <th>Location</th>
                                <th>Date</th>
                                <th>Status</th>

                            </tr>

                        </thead>


                        <tbody>

                            {events.map((item) => (

                                <tr key={item.id}>

                                    <td>{item.event_name}</td>

                                    <td>{item.location}</td>

                                    <td>{item.event_date}</td>

                                    <td>

                                        <span className="live-status">

                                            Live

                                        </span>

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    );
}

export default Schedule;